import React, { useState } from "react";
import Webcam from "react-webcam";
import QrReader from "react-web-qr-reader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import './Qr.css';

import { IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';







const QRModal = ({ videoConstraints, cameraFacingMode = "environment" ,qrModelflag,CloseQrFun,}) => {
  const navigate = useNavigate();
  const [cameraError, setCameraError] = useState(false);
  const [showScanner, setShowScanner] = useState(true);
      const handleBack=()=>{
        CloseQrFun()
    }

  const HeaderSecondary = () => {
  return (
    <Box
      sx={{
        height: 60,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fae14b', // Replace with your theme color
        px: 2,
        position:"fixed",
        zIndex:99999,
        width:"100%"
      }}
    >
      <IconButton sx={{ mr: 1 }} onClick={(e)=>{handleBack()}}>
        <CloseIcon fontSize="medium" />
      </IconButton>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 500, color: '#333', mt: 0.5 }}
      >
        Scan QR Code
      </Typography>
    </Box>
  );
};

  const handleError = (err) => {
    //console.error(err);
    setCameraError(true);
  };

  const handleScan = (result) => {
    if (result) {
     // console.log("Scanned QR result:", result);
      const machineIdIndex = result.data?.indexOf("machineId=");
      if (machineIdIndex !== -1) {
        const machineId = result.data.substring(machineIdIndex + 10);
        //console.log("Machine ID:", machineId);
        navigate(`/items?machineId=${machineId}`);
        setShowScanner(false);
      } else {
        toast.error("Machine ID Not Found", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    }
  };

  if (cameraError) {
    return (
      <div className="qr-modal-error">
        <p>No Camera Permission. Please reset your settings.</p>
      </div>
    );
  }



  return (
    <>
    {qrModelflag&&
      <div className="qr-modal-container">
      <HeaderSecondary/>
      {/* Webcam feed */}
      <Webcam
        audio={false}
        videoConstraints={videoConstraints}
        className="qr-modal-webcam"
      />

      {/* Blur overlay */}
      <div className="qr-modal-blur"></div>

      {/* QR Scanner */}
      {showScanner && (
        <div className="qr-modal-scanner">
          <QrReader
            delay={50}
            onError={handleError}
            onScan={handleScan}
            facingMode={cameraFacingMode}
            className="qr-reader"
          />
        </div>
      )}
    </div>}
    </>
  );
};

export default QRModal;
